"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const getGuardMedicalRecords_1 = tslib_1.__importDefault(require("./getGuardMedicalRecords"));
/**
 * get pending Guard Appointments test
 *
 * @param firestore
 * @param uid
 * @returns {Array<IMedicalRecordCompat>} array of MedicalRecordCompat
 */
async function getPendingGuardMedicalRecords(firestore, uid) {
    let pendingAppointments;
    try {
        pendingAppointments = await (0, getGuardMedicalRecords_1.default)(firestore, uid);
    }
    catch (err) {
        throw new Error(`${err}`);
    }
    const filteredPendingAppointments = pendingAppointments.filter((medRecord) => {
        const isClosed = medRecord.mr.dt_cierre === null;
        let isTomorrow;
        if (medRecord.attentionDate) {
            isTomorrow = (0, moment_1.default)(medRecord.attentionDate, "YYYY-MM-DD").isAfter((0, moment_1.default)().subtract(1, "day"));
            console.warn("you are using attentionDate, this will be obsolete in the near future, check if timestamp exists");
        }
        if (isClosed && isTomorrow) {
            return medRecord;
        }
    });
    return filteredPendingAppointments;
}
exports.default = getPendingGuardMedicalRecords;
